import React from "react";
import "./ProductsSection.css";
import productImage from "../../assets/Main-products.png"; 
import FloatingDots from "../FloatingDots";
import { motion } from "framer-motion";


const ProductsSection = () => {
  return (
    <section className="products-section">
      <div className="products-container">
        <div className="products-content">
  <p className="products-subtitle">OUR INDUSTRIAL PRODUCT</p>
  <h2 className="products-title">
    <span className="products-highlight">Sreenathji Enterprises</span> provides a wide range of high quality and competitively priced
products, which deliver outstanding value to its customers.
SE is one of the leading distributors in South India. Our approach to
fine and specialty distribution is to be your most reliable and resourceful partner.
we’ve sourced raw materials from suppliers around the world and marketed them to
manufacturers serving key industrial and consumer marketplaces. These
relationships are based on a long-standing expertise, exceptional follow-through and
the fastest turnaround times in the business. Below are the product ranges which we
offer.
  </h2>
</div>
        <div className="products-image-wrapper">
          <img
            src={productImage}
            alt="Sreenathji Enterprises Products"
            className="products-main-image"
          />
          <FloatingDots />
        </div>
        
      </div>
    </section>
  );
};

export default ProductsSection;
